if (!window.cCounselingJsLoaded) {
  window.cCounselingJsLoaded = true;
  const counselingDialg = document.getElementById('counseling-dialog');
  const counselingBtn = document.querySelector('.c_counseling__open');
  const counselingClose = document.querySelector('.c_counseling__dialog-close');

  if (counselingBtn) {
    counselingBtn.addEventListener('click', () => {
      if (counselingDialg) {
        counselingDialg.showModal();
      }
    });
  }

  if (counselingClose) {
    counselingClose.addEventListener('click', () => {
      if (counselingDialg) {
        counselingDialg.close();
      }
    });
  }

  if (counselingDialg) {
    counselingDialg.addEventListener('click', function(event) {
      if (event.target === counselingDialg) {
        counselingDialg.close();
      }
    });
  }
}